export default __webpack_public_path__ + "static/media/front.0ad13e68.png";